import React from "react";
import { Button } from "antd";

interface ErrorViewProps {
  error: string;
  onRetry: () => void;
  onGoBack: () => void;
  onUseUpload?: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({ error, onRetry, onGoBack, onUseUpload }) => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center p-5 bg-white">
      <div className="max-w-md text-center">
        <h2 className="mb-4 text-xl font-bold text-red-600">Camera Error</h2>
        <p className="mb-6 text-gray-600">{error}</p>

        <div className="flex flex-col gap-3">
          <div className="flex justify-center gap-3">
            <Button onClick={onRetry} type="primary">
              Try Again
            </Button>
            <Button onClick={onGoBack}>Go Back</Button>
          </div>

          {onUseUpload && (
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">or</span>
              </div>
            </div>
          )}

          {onUseUpload && (
            <Button onClick={onUseUpload} className="w-full mt-3" style={{ backgroundColor: '#f3f4f6', borderColor: '#d1d5db', color: '#374151' }}>
              Upload from Gallery
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
